import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../assets/category_logo.png';
import Home from '../assets/home.png';
import SignOut from '../assets/Sign_Out.png';

const HomeTopBar = () => { 
  const location = useLocation();
 
  const getPowerPointPath = () => {
    switch (location.pathname) {
      case '/demographics':
        return '/demographicspptx';
      case '/first-mention-awareness':
        return '/firstmentionawarenesspptx';
      case '/total-awareness':
        return '/totalawarenesspptx';
      case '/current-bank-usage':
        return '/currentbankusagepptx';
      case '/main-bank-usage-market-share':
        return '/mainbankusagepptx';
      case '/product-market-share':
        return '/productmarketsharepptx';
      case '/bank-consideration':
        return '/bankconsiderationpptx';
      case '/bank-preference':
        return '/bankpreferencepptx';
      case '/product-preference':
        return '/productpreferencepptx';
      case '/imagery-perceptions':
        return '/imageryperceptionspptx';
      case '/channel-interaction':
        return '/channelinteractionpptx';
      default:
        return '/powerpoint'; 
    }
  };

  return (
    <div className="category-nav">

      <div className='logo'>          
          <div className='logo-div'>
               <img src={Logo} alt="Standard Bank Logo"/>  
          </div>    
      </div>    

      {/* <div className='powerpoint'>       
          <Link to={getPowerPointPath()} style={{ textDecoration: 'none', color: 'white' }}>
              Get PowerPoint
          </Link>                
      </div>  */}

      <div className='home-and-signout'>             
          <Link to="/home">
              <img src={Home} alt="Home"/>
          </Link>
          <Link to="/">
              <img src={SignOut} alt="Sign Out"/>
          </Link>             
      </div>       
    </div>    
  );
};

export default HomeTopBar;

